import { EnvironmentHeritageLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const List = [
  {
    fileStoreId: "e3cca423-2adf-49e3-8d98-2487d856f530",
    label:
      "Application form for exemption of property tax for Heritage Building u/s 425K of KMC Act, 1980",
  },
  {
    fileStoreId: "d825ff41-0cf7-4b11-a809-54c8c9ef2277",
    label: "General Conditions for Exemption of Tax u/s 425K of KMC Act 1980",
  },
];

const Heritage_Exemption_of_Tax = () => (
  <TableStructure
    title="Exemption Forms"
    heading={"List of Forms"}
    list={List}
    columnNo={1}
    leftMenuList={EnvironmentHeritageLeftMenuList}
    longMenuList={true}
  />
);

export default Heritage_Exemption_of_Tax;
